import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";
import logo from "../assets/logo.png"; // Import logo
import homePage from '../pages/HomePage';
import About from "../pages/About";
import Forex from "../pages/Forex";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <a href="http://localhost:3000/">
        <img src={logo} alt="Logo" className="logo-image" /></a>
      </div>

      <div className={`nav-links ${menuOpen ? "open" : ""}`}>
        <a href="/">Home</a>
        <a href="/about">About</a>

        <div className="dropdown">
          <a href="#">Instruments ▼</a>
          <div className="dropdown-menu">
            <a href="/forex">Forex</a>
            <a href="/indices">Indices</a>
            <a href="/commodity">Commodities</a>
            <a href="/cryptocurrency">Cryptocurrency</a>
          </div>
        </div>

        <div className="dropdown">
          <a href="#">Platforms ▼</a>
          <div className="dropdown-menu">
            <a href="/GlobusPCTerminal">Globus PC Terminal</a>
            <a href="/GlobusWebTrader">Globus Web Trader</a>
            <a href="/GlobusMobileApp">Globus Mobile App</a>
          </div>
        </div>

        <a href="/legal">Legal Documents</a>
        <a href="/account">Accounts</a>
        <a href="/contact">Contact Us</a>
        <a href="/https://cabinet.globustrading.co/login">Login</a>
      </div>

      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>
    </nav>
  );
};



export default Navbar;


